// @ts-nocheck
export const LOCAL_STORAGE_KEYS = {
    appVersion: 'app-version',
    betsMonitorFilters: 'bets-monitor-filters',
};

class LocalStorage {
    static keysToRemove = [];

    static setItem(key, val) {
        localStorage.setItem(key, JSON.stringify(val));
    }

    static getItem(key) {
        const data = localStorage.getItem(key);

        try {
            return JSON.parse(data);
        } catch (ex) {
            return null;
        }
    }

    static removeItem(key) {
        localStorage.removeItem(key);
    }

    static clear() {
        LocalStorage.keysToRemove.forEach(key => {
            localStorage.removeItem(key);
        });
    }
}

export default LocalStorage;
